














import { Component, Mixins, Watch } from 'vue-property-decorator';
import { ListingFilter, ListingOrderBy } from 'client-website-ts-library/filters';
import { ListingStatus, ListingCategory } from 'client-website-ts-library/types';
import { View } from 'client-website-ts-library/plugins';

import Listings from '../components/Listings.vue';
import ListingSearch from '../components/ListingSearch.vue';

@Component({
  components: {
    Listings,
    ListingSearch,
  },
})
export default class PropertiesForSale extends Mixins(View) {
  private listingFilter: ListingFilter | null = null;

  @Watch('$route')
  updateRoute() {
    const filter = new ListingFilter({
      Statuses: [
        ListingStatus.Current,
        ListingStatus.UnderContract,
      ],
      Categories: [
        ListingCategory.ResidentialSale,
        ListingCategory.ResidentialLand,
        ListingCategory.Rural,
      ],
      PageSize: 9,
      OrderByStatements: [
        ListingOrderBy.CreateDateDesc,
      ],
    });

    const params = this.$route.query;

    try {
      if (params.suburbs && typeof params.suburbs === 'string') filter.Suburbs = params.suburbs.split('|').filter((s) => s && s.length);

      if (params.salesPriceMin && typeof params.salesPriceMin === 'string') filter.MinPrice = params.salesPriceMin;
      if (params.salesPriceMax && typeof params.salesPriceMax === 'string') filter.MaxPrice = params.salesPriceMax;

      if (params.beds && typeof params.beds === 'string') filter.MinBedrooms = params.beds;
      if (params.baths && typeof params.baths === 'string') filter.MinBathrooms = params.baths;

      if (params.areaMin && typeof params.areaMin === 'string') filter.MinLandArea = params.areaMin;
      if (params.areaMax && typeof params.areaMax === 'string') filter.MaxLandArea = params.areaMax;
      if (params.propertyId && typeof params.propertyId === 'string') filter.PropertyId = params.propertyId;
    } catch (ex) {
      console.error(ex);
    }

    this.listingFilter = filter;
  }

  mounted() {
    this.updateRoute();
  }

  handleFilter(newFilter: ListingFilter) {
    this.listingFilter = newFilter;
  }
}
